import React from "react";

const InvoicesIcon = ({ size = 12, color = "none", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill={color}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.524 1.27524C3.777 1.14875 4.07884 1 4.63636 1C5.19386 1 5.49573 1.14874 5.74873 1.27523L5.75595 1.27885C5.95395 1.37787 6.10723 1.4545 6.45455 1.45451C7.01686 1.45454 7.34991 1.24487 7.46095 1.16142C7.63382 1.03151 7.83805 1.04246 7.97905 1.10768C8.12186 1.17374 8.27273 1.33136 8.27273 1.56431V6.45454H9.63636C10.3892 6.45454 11 7.06432 11 7.81773V9.18182C11 9.60227 10.8936 9.94782 10.7106 10.2223C10.5295 10.494 10.2913 10.6694 10.0669 10.7815C9.84432 10.8929 9.62723 10.9462 9.46959 10.9725C9.37496 10.9883 9.278 11.0002 9.18182 11H2.81818C2.39774 11 2.05218 10.8936 1.77769 10.7106C1.50605 10.5295 1.33063 10.2913 1.21844 10.0669C1.10715 9.84432 1.05376 9.62723 1.02749 9.46964C1.01418 9.38973 1.00735 9.32218 1.00382 9.27282C1.00088 9.23168 1.00001 9.20732 1 9.18182V1.5643C1 1.33136 1.15084 1.17374 1.29366 1.10768C1.43467 1.04246 1.63891 1.0315 1.81177 1.1614C1.92281 1.24485 2.25586 1.45451 2.81818 1.45451C3.16552 1.45451 3.31876 1.37788 3.51676 1.27886L3.524 1.27524ZM1.9106 9.18182L1.90909 2.21987C2.15463 2.30262 2.45787 2.3636 2.81818 2.3636C3.37571 2.3636 3.67754 2.21486 3.93054 2.08837L3.93778 2.08475C4.13578 1.98573 4.28902 1.90909 4.63636 1.90909C4.98371 1.90909 5.13695 1.98572 5.33495 2.08474L5.34218 2.08836C5.59518 2.21485 5.897 2.36359 6.45455 2.3636C6.81486 2.36362 7.11809 2.30264 7.36364 2.21988V9.18182C7.36364 9.53773 7.43991 9.84 7.57432 10.0909H2.81818C2.55681 10.0909 2.391 10.0269 2.28197 9.95418C2.17009 9.87959 2.08982 9.77691 2.03156 9.66036C1.9724 9.54204 1.94056 9.41823 1.92421 9.32018C1.91653 9.27404 1.91187 9.22836 1.9106 9.18182ZM9.32018 10.0758C9.41823 10.0595 9.54205 10.0276 9.66036 9.96845C9.77691 9.91018 9.87959 9.82991 9.95418 9.71804C10.0269 9.609 10.0909 9.44318 10.0909 9.18182V7.81773C10.0909 7.567 9.88768 7.36364 9.63636 7.36364H8.27273V9.18182C8.27273 9.44318 8.33677 9.609 8.40945 9.71804C8.48405 9.82991 8.58673 9.91018 8.70327 9.96845C8.82159 10.0276 8.94541 10.0595 9.0435 10.0758C9.09145 10.0838 9.13041 10.0876 9.15559 10.0894C9.21041 10.0933 9.26623 10.0848 9.32018 10.0758Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
    <path
      d="M2.50005 4.5C2.50005 4.22386 2.72391 4 3.00005 4H6.00005C6.2762 4 6.50005 4.22386 6.50005 4.5C6.50005 4.77614 6.2762 5 6.00005 5H3.00005C2.72391 5 2.50005 4.77614 2.50005 4.5Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
    <path
      d="M2.50005 6.5C2.50005 6.22385 2.72391 6 3.00005 6H6.00005C6.2762 6 6.50005 6.22385 6.50005 6.5C6.50005 6.77615 6.2762 7 6.00005 7H3.00005C2.72391 7 2.50005 6.77615 2.50005 6.5Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
    <path
      d="M2.50005 8.5C2.50005 8.22385 2.72391 8 3.00005 8H6.00005C6.2762 8 6.50005 8.22385 6.50005 8.5C6.50005 8.77615 6.2762 9 6.00005 9H3.00005C2.72391 9 2.50005 8.77615 2.50005 8.5Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
  </svg>
);

export default InvoicesIcon;
